// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Experience-module--bx--text-truncate--end--0qsFX";
export var bxTextTruncateFront = "Experience-module--bx--text-truncate--front--vkEL2";
export var experience = "Experience-module--experience--zQyNI";
export var experienceContainer = "Experience-module--experience-container--3l-Xb";
export var selected = "Experience-module--selected--ntYlk";